import {combineReducers} from "redux";

import shareSportCouponReducer from "@atg-shop-shared/share-coupon-redux/src/shareSportCouponReducer";
import {betsReducer} from "@atg-sport-shared/pool-data-access-bets";
import {coupons} from "@atg-sport-shared/pool-data-access-coupons";
import {matchClockReducer} from "@atg-sport-shared/pool-data-access-match-clock";
import {matchesReducer} from "@atg-sport-shared/pool-data-access-matches";
import {offeringsReducer} from "@atg-sport-shared/pool-data-access-offering";
import {outcomes} from "@atg-sport-shared/pool-data-access-outcomes";
import {purchaseReducer} from "@atg-sport-shared/pool-data-access-purchase";
import {settingsReducer} from "@atg-sport-shared/pool-data-access-settings";
import {statisticsReducer} from "@atg-sport-shared/pool-data-access-statistics";

import type {Big9State} from "@atg-sport-shared/pool-types";
import type {AnyAction} from "redux";

// @ts-ignore
const combinedReducers = combineReducers<Big9State>({
    coupons,
    outcomes,
    offerings: offeringsReducer,
    settings: settingsReducer,
    matches: matchesReducer,
    matchClocks: matchClockReducer,
    statistics: statisticsReducer,
    bets: betsReducer,
    // @ts-ignore
    purchase: purchaseReducer,
    shareSportCoupon: shareSportCouponReducer,
});

export const rootReducer = (state: Big9State, action: AnyAction) =>
    combinedReducers(state, action);
